var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-index" }, [
    _c("div", { staticClass: "main" }, [
      _c("img", {
        staticClass: "czur-logo",
        attrs: { src: require("../assets/images/czur_logo.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "czur-cloud" }, [
        _vm._v(_vm._s(_vm.$t("index.loginText")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text text-bold" }, [
        _vm._v(_vm._s(_vm.$t("index.mobileTip"))),
        _c("br"),
        _vm._v(_vm._s(_vm.$t("index.youCan")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _vm._v(_vm._s(_vm.$t("index.mobileTextOne")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text pad-le-ri" }, [
        _vm._v(_vm._s(_vm.$t("index.mobileTextTwo")))
      ]),
      _vm._v(" "),
      _vm.downloadCn
        ? _c(
            "a",
            {
              staticClass: "download-btn",
              attrs: {
                href: "https://www.czur.com/cn/app/czur",
                target: "_blank"
              }
            },
            [_vm._v(_vm._s(_vm.$t("index.downloadApp")))]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.downloadCn
        ? _c(
            "a",
            {
              staticClass: "download-btn",
              attrs: {
                href: "https://www.czur.com/en/app/czur",
                target: "_blank"
              }
            },
            [_vm._v(_vm._s(_vm.$t("index.downloadApp")))]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "site-url" }, [_vm._v("www.czur.cc")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12a0d350", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a0d350","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileIndex.vue
// module id = null
// module chunks = 